import React from 'react'
import "../../styles/event-form.css"
import { Script } from 'gatsby';

const EventForm = class extends React.Component {
  componentDidMount() {
    const formWrapper = document.getElementById("event-form");
    const recaptchaWrapper = document.getElementById("recaptcha-wrapper");

    const formScript = document.createElement("script");
    formScript.async = false;
    formScript.defer = false;
    formScript.src =
      "https://api.tripleseat.com/v1/leads/ts_script.js?lead_form_id=16568&public_key=bb27dbe6d3ef4a4da1dada83b6ebd61f6e5fb6c9";
    formWrapper.appendChild(formScript);


    const recaptchaScript = document.createElement("script");
    recaptchaScript.async = false;
    recaptchaScript.defer = false
    recaptchaScript.src =
      "https://www.google.com/recaptcha/api.js";
    recaptchaWrapper.appendChild(recaptchaScript);
  }
  render() {
    return (
      <>
        <div id="recaptcha-wrapper" />
        <div id="event-form" className='max-w-3xl mx-auto'>
          {/* <div class="g-recaptcha" data-sitekey="6LeC4CkUAAAAAK39iB_y_XhgS1EhvArMwecdZmCr"></div> */}
        </div>
        {/* <CaptchaCheck /> */}
        <Script id="google-recaptcha" src="https://www.google.com/recaptcha/api.js" strategy="idle" />
      </>
    );
  }
}

// function CaptchaCheck() {

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (!document.querySelector('iframe[title="reCAPTCHA"]')) {
//         window.location.reload();
//       }
//     }, 4000);
//     return () => clearInterval(interval);

//   }, []);

//   return (
//     <></>
//   );
// }

export default EventForm